import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import KitchenDesignPrice from "../pages/kitchendesignprice/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/kitchendesignprice",
    element: <KitchenDesignPrice />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
